import { Injectable } from '@angular/core';

/**
 * 'flow'  → sessionStorage: tied to one in-progress quote/claim/edit in this
 *           tab. Never shared across tabs, cleared when the tab closes.
 * 'user'  → localStorage: tied to the logged-in person (or the device) and
 *           shared across every tab — auth, remembered login, prefs.
 */
export type StorageScope = 'flow' | 'user';

@Injectable({ providedIn: 'root' })
export class StorageService {

  get(key: string, scope: StorageScope): string | null {
    try {
      return this.backing(scope).getItem(key);
    } catch {
      return null;
    }
  }

  set(key: string, value: string, scope: StorageScope): void {
    try {
      this.backing(scope).setItem(key, value);
    } catch {
    }
  }

  getJson<T = any>(key: string, scope: StorageScope): T | null {
    const raw = this.get(key, scope);
    if (raw == null) {
      return null;
    }
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  }

  setJson(key: string, value: unknown, scope: StorageScope): void {
    this.set(key, JSON.stringify(value), scope);
  }

  remove(key: string, scope: StorageScope): void {
    try {
      this.backing(scope).removeItem(key);
    } catch {
    }
  }

  private backing(scope: StorageScope): Storage {
    return scope === 'user' ? localStorage : sessionStorage;
  }
}
